/**
 * Maps UI billing frequency strings to API billingInterval enum values.
 * Based on API example: 3 = monthly, 4 = yearly.
 */
export const BILLING_INTERVAL_MAP: Record<string, number> = {
  daily: 1,
  weekly: 2,
  monthly: 3,
  yearly: 4,
};

/**
 * Maps UI billing frequency to API billingDuration.
 * billingDuration represents the unit multiplier (e.g. 1 = 1 month, 2 = 2 years).
 * For monthly: 1, for yearly: 2 (as per API example).
 */
export const BILLING_DURATION_MAP: Record<string, number> = {
  daily: 1,
  weekly: 1,
  monthly: 1,
  yearly: 2,
};

export function getBillingInterval(frequency: string): number {
  return BILLING_INTERVAL_MAP[frequency] ?? 3;
}

export function getBillingDuration(frequency: string): number {
  return BILLING_DURATION_MAP[frequency] ?? 1;
}

const BILLING_PAIR_TO_FREQUENCY: [number, number, string][] = [
  [1, 1, "daily"],
  [2, 1, "weekly"],
  [3, 1, "monthly"],
  [4, 2, "yearly"],
];

/** Map stored API interval/duration back to a frequency key for selects. */
export function inferBillingFrequency(interval: number, duration: number): string {
  const hit = BILLING_PAIR_TO_FREQUENCY.find(
    ([i, d]) => i === interval && d === duration
  );
  if (hit) {
    return hit[2];
  }
  const fallback = Object.entries(BILLING_INTERVAL_MAP).find(
    ([, v]) => v === interval
  )?.[0];
  return fallback ?? "monthly";
}

export function subscriptionBillingLabel(interval: number, duration: number): string {
  const key = inferBillingFrequency(interval, duration);
  return key.charAt(0).toUpperCase() + key.slice(1);
}
